import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { rootTranslationRef } from './root';

export const rootTranslations = createTranslationResource({
  ref: rootTranslationRef,
  translations: {
    'pt-BR': () => import('./root-pt-BR'),
  },
});
